import React from 'react';

export const AutomationIcon = ({ color }) => {
    return (
        <svg width="17" height="17" viewBox="0 0 17 17" fill={color} xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M0.687661 5.04903L15.6747 0.0533406C16.4608 -0.208694 17.2087 0.539181 16.9467 1.32529L11.951 16.3123C11.6677 17.1622 10.4983 17.2453 10.0976 16.4441L7.27061 10.79L11.0303 7.03033C11.3232 6.73744 11.3232 6.26256 11.0303 5.96967C10.7374 5.67678 10.2626 5.67678 9.96967 5.96967L6.20995 9.72939L0.555945 6.90238C-0.245335 6.50174 -0.162224 5.33232 0.687661 5.04903Z" fill={color}/>
        </svg>
    )
};
